// API 配置常量
// 避免循环依赖，将 API 基础 URL 配置独立出来

const apiBaseUrlLogin = process.env.VUE_APP_API_BASE_LOGIN_URL  // 登录
const apiBaseUrl = process.env.VUE_APP_API_BASE_URL  // 业务

// const apiBaseUrlLogin = "http://124.70.178.197:10009/serve"  // 登录
// const apiBaseUrl =  "http://124.70.178.197:9099/serve"  // 业务

const apiBaseUrlUpload = `${apiBaseUrlLogin}/sys/common/upload2`
const apiBaseUrlDownload = `${apiBaseUrlLogin}/`
const apiContactAvatar = `${apiBaseUrlLogin}/jksaas-mgt/mgt/sys/common/static2/`

export {
  apiBaseUrl,
  apiBaseUrlLogin,
  apiBaseUrlUpload,
  apiBaseUrlDownload,
  apiContactAvatar
}
